import { createApp } from 'vue'
import FundraiseForm from './FundraiseForm'

const el = '.kb-component--fundraise-form'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((FundraiseFormDOM) => {
            const guid = FundraiseFormDOM.dataset.guid
            const cancelUrl = FundraiseFormDOM.dataset.cancelUrl
            const draft = FundraiseFormDOM.dataset.draft
                ? JSON.parse(FundraiseFormDOM.dataset.draft)
                : null
            const donationSettings = FundraiseFormDOM.dataset?.donationSettings
            if (donationSettings) {
                Store.commit(
                    'fundraising/set_donation_settings',
                    JSON.parse(donationSettings)
                )
            }
            const firstName = FundraiseFormDOM.dataset.firstname
            const lastName = FundraiseFormDOM.dataset.lastname
            const email = FundraiseFormDOM.dataset.email
            const phone = FundraiseFormDOM.dataset.phone
            const showPersonalInformationInput = FundraiseFormDOM.dataset.showpersonalinformationinput === 'True'
            const isMindegave = FundraiseFormDOM.hasAttribute('is-mindegave')
            const showUnsavedChangesWarning = FundraiseFormDOM.hasAttribute('show-unsaved-changes-warning')
            const component = createApp(FundraiseForm, {
                fundraisingCampaignId: guid,
                cancelUrl,
                isMindegave,
                showUnsavedChangesWarning,
                draft,
                showPersonalInformationInput,
                firstName,
                lastName,
                email,
                phone
            }).use(Store)
            component.mount(FundraiseFormDOM)
        })
    }
}
